import { isEqual } from "date-fns";
import React from "react";
import { RCCBadge } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { CleanHeader } from "src/components/List/styles";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { IListOfMeetings } from "../../interface";

const ListOfMeetings: React.FC<IListOfMeetings> = ({
	data,
	options,
	layout,
	origin
}) => {
	const { translate,currentLanguage} = useTranslation();
    
	const colDate = (row:any) => (
		<>
			{
				isEqual(new Date(row.ara001Dthrinicio),new Date(row.ara001Dthrfim)) ?
					<span>{formatDate(row.ara001Dthrinicio,currentLanguage,true)}</span>
					:
					<span>{formatDate(row.ara001Dthrinicio,currentLanguage,true)} - {formatDate(row.ara001Dthrfim,currentLanguage,true)}</span>
			}
		</>
	);

	const colResponsible = (row: any) => (
		<>
			<UserColumn 
				name={row.ara001Efa005Nome}
				image={row.ara001Efa005Imagem}	
			/>
		</>
	);

	const colSituation = (row:any) => (
		<RCCBadge color={row.ara001Finalizada === "S" ? "green" : "red"}
			styleInline="font-size: 0.83rem;"
		>
			{row.ara001Finalizada === "S" ? translate("Finalizada") : translate("Não finalizada")}
		</RCCBadge>
	);

	return (
		<>
			<List 
				data={data}
				headerHiddenXs
				showHeader
				styleInline={CleanHeader}
				layout={layout}
				columns={ origin && origin === "dashboard" ?  [
					{
						idColumn: "ara001Assunto",
						nameColumn: translate("Assunto"),
						xs: 12,
						sm: 3,
						justify: "left",
						bold: true
					},
					{
						idColumn: "ara001Dthrinicio",
						nameColumn: translate("Data"),
						xs: 12,
						sm: 2,
						justify: "left",
						cellRenderer: colDate 
					},
					{
						idColumn: "ara001Efa005Nome",
						nameColumn: translate("Responsável"),
						xs: 12,
						sm: 3,
						justify: "left",
						cellRenderer: colResponsible
					},
					{
						idColumn: "taa008Descricao",
						nameColumn: translate("Sala de reunião"),
						xs: 12,
						sm: 2,
						justify: "left"
					},
					{
						idColumn: "taa010Descricao",
						nameColumn: translate("Tipo"),
						xs: 12,
						sm: 2,
						hidden:["sm"],
						justify: "left"
					},
					{
						idColumn: "options",
						nameColumn: " ",
						styleInline: "position: absolute; right: -2px; bottom: 0; width: fit-content;",
						hideHeader: true,
						cellRenderer: options
					}
				] : [
					{
						idColumn: "ara001Assunto",
						nameColumn: translate("Assunto"),
						xs: 12,
						sm: 4,
						md: 3,
						justify: "left",
						bold: true
					},
					{
						idColumn: "ara001Dthrinicio",
						nameColumn: translate("Data"),
						xs: 12,
						sm: 2,
						justify: "left",
						cellRenderer: colDate 
					},
					{
						idColumn: "ara001Efa005Nome",
						nameColumn: translate("Responsável"),
						xs: 12,
						sm: 2,
						justify: "left",
						cellRenderer: colResponsible
					},
					{
						idColumn: "taa008Descricao",
						nameColumn: translate("Sala de reunião"),
						xs: 12,
						sm: 2,
						justify: "left"
					},
					{
						idColumn: "taa010Descricao",
						nameColumn: translate("Tipo"),
						xs: 12,
						sm: 1,
						hidden:["sm"],
						justify: "left"
					},
					{
						idColumn: "ara001Finalizada",
						nameColumn: translate("Situação"),
						xs: 12,
						sm: 2,
						justify: "left",
						cellRenderer: colSituation
					},
					{
						idColumn: "options",
						nameColumn: " ",
						styleInline: "position: absolute; right: -2px; bottom: 0; width: fit-content !important;",
						hideHeader: true,
						cellRenderer: options
					}
				]}
			/>
		</>
	);

};

export default ListOfMeetings;
